import React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import Home from './Pages/Home';
import Header from './Components/Header';
import Myprofile from './Pages/Myprofile';
import Wallet from './Pages/Wallet';
import Wallettrans from './Pages/Wallettrans';
import Contactus from './Pages/Contactus';
import Footer from './Components/Footer';
import ProductList from './Pages/ProductList';
import Slideproductlist from './Pages/Slideproductlist';
import Productdetails from './Pages/Productdetails';
import Aboutus from './Pages/Aboutus';
import Searchresult from './Pages/Searchresult';
import Media from './Pages/Media';
import Cart from './Pages/Cart';
import Privacypolicy from './Pages/Privacypolicy';
import Termsandconditions from './Pages/Termsandconditions';
import Myorders from './Pages/Myorders';
import Orderdetails from './Pages/Orderdetails';
import Payment from './Pages/Payment';
import Agentdashboard from './Pages/Agentdashboard';
import Agentsalesreport from './Pages/Agentsalesreport';
import RefundPolicy from './Pages/Refundpolicy';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/index" element={<Home/>} />
          <Route path="/home" element={<Home/>} />
          <Route path="/my-profile" element={<Myprofile/>} />
          <Route path="/my-orders" element={<Myorders/>} />
          <Route path="/orders-details/:order" element={<Orderdetails/>} />
          <Route path="/wallet" element={<Wallet/>} />
          <Route path="/wallet-transfer" element={<Wallettrans/>}/>
          <Route path="/contact-us" element={<Contactus/>}/>
          <Route path="/product-details/:id2" element={<Productdetails/>}/>
          <Route path="/search/:id" element={<Searchresult/>}/>
          <Route path="/about-us" element={<Aboutus/>}/>
          <Route path="/privacy-policy" element={<Privacypolicy/>}/>
          <Route path="/terms&conditions" element={<Termsandconditions/>}/>
          <Route path="/refund-policy" element={<RefundPolicy/>}/>
          <Route path="/media" element={<Media/>}/>
          <Route path="/cart" element={<Cart/>}/>
          <Route path="/payment" element={<Payment/>}/>
          <Route path="/agent-dashboard" element={<Agentdashboard/>}/>
          <Route path="/agent-sales" element={<Agentsalesreport/>}/>
          <Route path="/products/*" element={<ProductList/>}/>
          <Route path="/new-arrivals" element={<Slideproductlist url='api/method/ecom.api.latest_items?pin='/>}/>
          <Route path="/todays-deal" element={<Slideproductlist url='api/method/ecom.api.todays_deal?pin='/>}/>
          <Route path="/best-sellers" element={<Slideproductlist url='api/method/ecom.api.best_sellers?pin='/>}/>
          <Route path="/recommended-for-you" element={<Slideproductlist url='api/method/ecom.api.recommended?pin='/>}/>


        </Routes>
        <Footer/>
        </BrowserRouter>
  </React.StrictMode>

);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
